import { render, staticRenderFns } from "./supplierDetails.vue?vue&type=template&id=6febb34f&scoped=true"
import script from "./supplierDetails.vue?vue&type=script&lang=js"
export * from "./supplierDetails.vue?vue&type=script&lang=js"
import style0 from "./supplierDetails.vue?vue&type=style&index=0&id=6febb34f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6febb34f",
  null
  
)

export default component.exports